import { useQuery } from "@tanstack/react-query";
import { getPlayoffs, getStandings } from "../api/standings";

const qk = {
  standings: (season) => ["standings", season ?? "current"],
  playoffs: (season) => ["playoffs", season ?? "current"],
};

export function useStandings(season, options = {}) {
  return useQuery({
    queryKey: qk.standings(season),
    queryFn: () => getStandings(season),
    ...options,
  });
}

export function usePlayoffs(season, options = {}) {
  return useQuery({
    queryKey: qk.playoffs(season),
    queryFn: () => getPlayoffs(season),
    ...options,
  });
}
